"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var declarePropsNonNullish = function () { return function (props) {
    return props;
}; };
exports.default = declarePropsNonNullish;
